(function () {
function getProductJson(sectionId) {
var script = document.getElementById('ProductJson-' + sectionId);
if (!script) return null;
try { return JSON.parse(script.textContent); } catch (e) { return null; }
}
function getOverridesJson(sectionId) {
var script = document.getElementById('VariantMediaOverrides-' + sectionId);
if (!script) return null;
try { return JSON.parse(script.textContent); } catch (e) { return null; }
}
function normalize(str) {
if (!str) return '';
return str.toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
function setSelectValues(values, product) {
var optionKeys = ['option1', 'option2', 'option3'];
var selects = document.querySelectorAll('select.single-option-selector');
optionKeys.forEach(function (key, idx) {
if (idx >= product.options.length) return;
var value = values[idx];
if (value == null) return;
var select = selects[idx];
if (!select) return;
if (select.value === value) return;
select.value = value;
select.dispatchEvent(new Event('change', { bubbles: true }));
});
}
function applyExactMatch(product, mediaId) {
var matches = product.variants.filter(function (v) { return v.featured_media && String(v.featured_media.id) === String(mediaId); });
if (!matches.length) return false;
var optionKeys = ['option1', 'option2', 'option3'];
var values = optionKeys.map(function (key) {
var vals = matches.map(function (v) { return v[key]; });
var unique = vals.filter(function (v, i) { return vals.indexOf(v) === i; });
return unique.length === 1 ? unique[0] : null;
});
setSelectValues(values, product);
return true;
}
function applyOverrideMatch(overrides, product, mediaId) {
if (!overrides) return false;
var variantIds = Object.keys(overrides).filter(function (id) { var list = overrides[id] || []; return list.some(function (fid) { return String(fid) === String(mediaId); }); });
if (!variantIds.length) return false;
var matches = product.variants.filter(function (v) { return variantIds.indexOf(String(v.id)) !== -1; });
if (!matches.length) return false;
var optionKeys = ['option1', 'option2', 'option3'];
var values = optionKeys.map(function (key) { var vals = matches.map(function (v) { return v[key]; }); var unique = vals.filter(function (v, i) { return vals.indexOf(v) === i; }); return unique.length === 1 ? unique[0] : null; });
setSelectValues(values, product);
return true;
}
function applyFilenameMatch(product, thumb) {
var filename = normalize(thumb.getAttribute('data-media-filename'));
var alt = normalize(thumb.getAttribute('data-media-alt'));
var haystack = filename + ' ' + alt;
if (!haystack.trim()) return false;
var optionKeys = ['option1', 'option2', 'option3'];
var values = [];
var matchedAny = false;
optionKeys.forEach(function (key, idx) {
if (idx >= product.options.length) { values.push(null); return; }
var distinctValues = product.variants.map(function (v) { return v[key]; }).filter(function (v, i, arr) { return v != null && arr.indexOf(v) === i; });
var found = distinctValues.filter(function (val) { return haystack.indexOf(normalize(val)) !== -1; });
if (found.length === 1) { values.push(found[0]); matchedAny = true; } else { values.push(null); }
});
if (!matchedAny) return false;
setSelectValues(values, product);
return true;
}
function forceMediaDisplay(sectionId, mediaId) {
var fullId = sectionId + '-' + mediaId;
var container = document.getElementById('ProductSection-' + sectionId) || document;
var wrappers = container.querySelectorAll('[data-product-single-media-wrapper]');
for (var i = 0; i < wrappers.length; i++) {
var w = wrappers[i];
if (w.getAttribute('data-media-id') === fullId) { w.classList.remove('hide'); } else { w.classList.add('hide'); }
}
var thumbs = container.querySelectorAll('[data-thumbnail-id]');
for (var j = 0; j < thumbs.length; j++) {
var t = thumbs[j];
if (t.getAttribute('data-thumbnail-id') === fullId) { t.classList.add('active-thumb'); t.setAttribute('aria-current', 'true'); } else { t.classList.remove('active-thumb'); t.removeAttribute('aria-current'); }
}
}
document.addEventListener('click', function (evt) {
var thumb = evt.target.closest('[data-thumbnail-id]');
if (!thumb) return;
var raw = thumb.getAttribute('data-thumbnail-id');
if (!raw) return;
var match = raw.match(/^(.+)-(\d+)$/);
if (!match) return;
var sectionId = match[1];
var mediaId = match[2];
var product = getProductJson(sectionId);
if (!product || !product.variants || !product.options) return;
var overrides = getOverridesJson(sectionId);
var matched = applyOverrideMatch(overrides, product, mediaId) || applyExactMatch(product, mediaId) || applyFilenameMatch(product, thumb);
if (matched) {
forceMediaDisplay(sectionId, mediaId);
}
});
})();
(function () {
  function getProductJson(sectionId) {
    var script = document.getElementById('ProductJson-' + sectionId);
    if (!script) return null;
    try { return JSON.parse(script.textContent); } catch (e) { return null; }
  }

  function updateOptionAvailability(sectionId) {
    var product = getProductJson(sectionId);
    if (!product || !product.variants || !product.options) return;

    var selects = document.querySelectorAll('.single-option-selector-' + sectionId);
    if (!selects.length) return;

    var optionKeys = ['option1', 'option2', 'option3'];
    var currentValues = [];
    selects.forEach(function (select) { currentValues.push(select.value); });

    var changedSelect = null;

    selects.forEach(function (select, i) {
      if (i === 0) return; // Modelo nunca se filtra
      if (changedSelect) return; // corregimos un selector por pasada; el resto se resuelve en cascada

      var options = select.querySelectorAll('option');
      var firstValid = null;
      var selectedIsValid = false;

      options.forEach(function (opt) {
        var exists = product.variants.some(function (variant) {
          if (variant[optionKeys[i]] !== opt.value) return false;
          for (var j = 0; j < i; j++) {
            if (variant[optionKeys[j]] !== currentValues[j]) return false;
          }
          return true;
        });

        if (exists) {
          opt.disabled = false;
          opt.style.display = '';
          if (firstValid === null) firstValid = opt.value;
          if (opt.value === currentValues[i]) selectedIsValid = true;
        } else {
          opt.disabled = true;
          opt.style.display = 'none';
        }
      });

      // Si la opción seleccionada ya no existe para el Modelo actual,
      // autoseleccionamos la primera opción válida y avisamos al resto del tema.
      if (!selectedIsValid && firstValid !== null) {
        select.value = firstValid;
        currentValues[i] = firstValid;
        changedSelect = select;
      }
    });

    if (changedSelect) {
      var evt = new Event('change', { bubbles: true });
      changedSelect.dispatchEvent(evt);
    }
  }

  function initSection(sectionId) {
    updateOptionAvailability(sectionId);
    var selects = document.querySelectorAll('.single-option-selector-' + sectionId);
    selects.forEach(function (select) {
      select.addEventListener('change', function () {
        updateOptionAvailability(sectionId);
      });
    });
  }

  document.querySelectorAll('script[id^="ProductJson-"]').forEach(function (script) {
    var sectionId = script.id.replace('ProductJson-', '');
    initSection(sectionId);
  });
})();